import { Icon } from '@livable/saas-react-components';
import { Typography, Paper, Grid, Button } from '@mui/material';
import { observer } from 'mobx-react-lite';
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Link as RouterLink } from 'react-router-dom';
import { PROPERTY_STEPS } from 'src/constants/property';
import ArrowsList from 'src/components/general/ArrowsList';
import thankYouImg from 'src/img/thank-you.svg';
import { useStore } from 'src/stores';
import useStyles from './styles';
export const PropertyWelcomePage = observer(_ref => {
  let _ref$handleStep = _ref.handleStep,
    handleStep = _ref$handleStep === void 0 ? () => {} : _ref$handleStep,
    notCompletedPropertyId = _ref.notCompletedPropertyId,
    registerActionBack = _ref.registerActionBack,
    registerActionNext = _ref.registerActionNext;
  const store = useStore();
  const classes = useStyles();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const sections = [{
    icon: /*#__PURE__*/React.createElement(Icon, {
      fontSize: "huge",
      pattern: "gradient",
      type: "property"
    }),
    title: t('add_new_property_flow.provide_building_info'),
    list: {
      title: t('add_new_property_flow.its_easy_to_get_started'),
      items: [t('add_new_property_flow.building_addresses'), t('add_new_property_flow.banking_information'), t('add_new_property_flow.list_of_amenities_in_unit'), t('add_new_property_flow.unit_details'), t('add_new_property_flow.total_building_sq_ft'), t('add_new_property_flow.team_member_information'), t('add_new_property_flow.list_of_common_area')]
    }
  }, {
    icon: /*#__PURE__*/React.createElement(Icon, {
      fontSize: "huge",
      pattern: "gradient",
      type: "settings"
    }),
    title: t('add_new_property_flow.set_up_your_utilities'),
    list: {
      title: t('add_new_property_flow.we_need_billing_information'),
      items: [t('add_new_property_flow.list_of_utilities'), t('add_new_property_flow.account_numbers')]
    }
  }, {
    icon: /*#__PURE__*/React.createElement(Icon, {
      fontSize: "huge",
      pattern: "gradient",
      type: "user-add"
    }),
    title: t('add_new_property_flow.enroll_your_residents'),
    list: {
      title: t('add_new_property_flow.once_we_have_building_info'),
      items: [t('add_new_property_flow.rent_roll'), t('add_new_property_flow.resident_contact_information'), t('add_new_property_flow.occupancy_by_unit'), t('add_new_property_flow.not_to_exceed_rates')]
    }
  }];
  if (notCompletedPropertyId) {
    store.addNewProperty.changeCompletedStep(PROPERTY_STEPS.PropertyInformation);
    handleStep(PROPERTY_STEPS.PropertyInformation)();
  }
  const goToNextStep = () => {
    store.addNewProperty.changeCompletedStep(PROPERTY_STEPS.PropertyInformation);
    handleStep(PROPERTY_STEPS.PropertyInformation)();
  };
  useEffect(() => {
    if (store.addNewProperty.completedStep === 0) {
      store.addNewProperty.cleanUpPropertyInformation();
      store.addNewProperty.feeStructureV2.clearFees();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    if (registerActionNext !== undefined) registerActionNext(() => {
      goToNextStep();
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [registerActionNext]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Paper, {
    variant: "evenWrapper"
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.content
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Typography, {
    variant: "h3"
  }, t('add_new_property_flow.welcome')), /*#__PURE__*/React.createElement(Typography, {
    variant: "body1",
    color: "light"
  }, t('add_new_property_flow.see_how_it_works')), /*#__PURE__*/React.createElement("div", {
    className: classes.smSection
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body3",
    component: "p"
  }, t('add_new_property_flow.livable_mission')))))), /*#__PURE__*/React.createElement("div", {
    className: classes.xsSection
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    rowSpacing: 10,
    columnSpacing: 10
  }, sections.map((section, i) => /*#__PURE__*/React.createElement(Grid, {
    item: true,
    sm: i === 2 ? 12 : 6,
    lg: 4,
    key: i
  }, /*#__PURE__*/React.createElement(Paper, {
    variant: "evenWrapper",
    className: classes.gridSection
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.icon
  }, section.icon), /*#__PURE__*/React.createElement(Typography, {
    variant: "h4"
  }, section.title), /*#__PURE__*/React.createElement(ArrowsList, {
    key: i,
    list: section.list
  })))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    sm: 12
  }, /*#__PURE__*/React.createElement(Paper, {
    variant: "evenWrapper"
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.content
  }, /*#__PURE__*/React.createElement("img", {
    src: thankYouImg,
    width: "120",
    height: "120",
    alt: "thank you image",
    className: classes.sideImg
  }), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Typography, {
    variant: "h3"
  }, t('add_new_property_flow.thank_you')), /*#__PURE__*/React.createElement("div", {
    className: classes.smSection
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body3",
    component: "p"
  }, t('add_new_property_flow.thanks_for_joining_us'))))))))), registerActionBack === undefined && registerActionNext === undefined && /*#__PURE__*/React.createElement("div", {
    className: classes.pageFooter
  }, /*#__PURE__*/React.createElement(Button, {
    component: RouterLink,
    to: "/active_dashboard",
    variant: "text",
    'custom-attribute': '779-property-add-page'
  }, t('buttons.back_to_dashboard')), /*#__PURE__*/React.createElement(Button, {
    onClick: goToNextStep,
    variant: "priority",
    'custom-attribute': '780-property-add-page'
  }, t('general.begin'), ": ", t('add_new_property_flow.property_information'))));
});
PropertyWelcomePage.propTypes = {
  handleStep: PropTypes.func
};